import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import type { Dayjs } from 'dayjs';
import { t } from 'ember-intl';
import changeColorClass from 'lumen/helpers/change-color-class';
import type { Rate } from 'lumen/models';

import styles from './pricing-assistant-table-tooltip.module.css';

interface HotelPricingAssistantTableTooltipsTooltipCompetitorCellSignature {
  Args: {
    date: Dayjs;
    rate: Rate;
    refDaysAgo: number;
  };
}

export default class HotelPricingAssistantTableTooltipsTooltipCompetitorCell extends Component<HotelPricingAssistantTableTooltipsTooltipCompetitorCellSignature> {
  @service declare dates: Services['dates'];

  get formattedDate(): string {
    return this.args.date.format(
      this.dates.partialDateFormat.WEEKDAY_AND_DATE_LONG,
    );
  }

  <template>
    <EmberTooltip
      @side="bottom"
      @tooltipClass="base-tooltip {{styles.container}}"
    >
      <div class="{{styles.header}} flex items-center p-400">
        <h4>
          {{this.formattedDate}}
        </h4>
      </div>
      <div>
        <table class="default-table {{styles.table}}">
          <tbody>
            {{! Row for Room Name }}
            <tr>
              <td class="{{styles.table-row-cell}} text-200--regular">

                <p class="text-200--bold">{{t "pricing_manager.room"}}</p>

                {{! For competitors, we can't know the room name if we don't have rate value (for instance, sold out means there's nothing on site at all, so nothing is scraped) }}
                {{#if @rate.roomName}}
                  <p
                    class="text-200--regular text-right text-wrap"
                  >{{@rate.roomName}}
                  </p>
                {{else}}
                  <p class="text-200--regular">{{t "general.missing"}}</p>
                {{/if}}

              </td>
            </tr>

            {{! Row for Comparison Rate }}
            <tr>
              <td class="{{styles.table-row-cell}} text-200--regular">

                <div>
                  <p class="text-200--bold">{{t
                      "pricing_manager.current_price"
                    }}
                  </p>
                  <p class={{styles.comparison-line}}>{{t
                      "general.daysago"
                      count=@refDaysAgo
                    }}</p>
                </div>

                <div class="flex flex-col items-end">

                  <p>{{@rate.formattedRate}}</p>

                  {{#if @rate.priceChangeSinceYesterday}}
                    <p
                      class={{changeColorClass @rate.priceChangeSinceYesterday}}
                    >{{@rate.formattedPriceChangeSinceYesterday}}
                    </p>
                  {{else}}
                    <p>{{t "general.missing"}} </p>
                  {{/if}}
                </div>

              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </EmberTooltip>
  </template>
}
